import * as fromDatatype from '../datatype-library/index';

export interface bl_sys_vendor_login_subject_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  subject_guid: fromDatatype.GuidDataFieldInterface;
  vendor_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  rank: fromDatatype.VarcharDatatypeInterface;
}

export class bl_sys_vendor_login_subject_link_RowClass implements bl_sys_vendor_login_subject_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  subject_guid: fromDatatype.GuidDataFieldInterface;
  vendor_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  rank: fromDatatype.VarcharDatatypeInterface;
}
